import React, { useState } from "react";
import { programRegionProgressData } from "../../../types/programRegionProgressData";
import { ChevronDown } from "lucide-react";

const Lanscape = () => {
  const data = programRegionProgressData["akses-layanan"];
  const [activeProvince, setActiveProvince] = useState<string | null>(null);
  const [showAll, setShowAll] = useState(false);

  const visibleData = showAll ? data : data.slice(0, 5);

  return (
    <section className="pt-20 pb-10 px-6">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-start">
        {/* KIRI — Narasi */}
        <div>
          <h2 className="text-xl md:text-4xl font-bold text-slate-800 mb-6 max-sm:text-center max-sm:w-[90%] max-sm:mx-auto">
            Landscape Kemiskinan <span className=" text-red-600">di Indonesia </span>
          </h2>

          <p className="text-slate-600 leading-relaxed mb-4 text-base md:text-base">
            Kemiskinan masih menjadi tantangan struktural di Indonesia. Jutaan masyarakat hidup dengan keterbatasan akses terhadap pendidikan, layanan kesehatan, dan peluang ekonomi yang layak.
          </p>

          <p className="text-slate-600 leading-relaxed mb-6 text-base md:text-base">
            Ketimpangan wilayah, rendahnya kualitas pekerjaan, serta kerentanan terhadap krisis ekonomi dan bencana alam memperparah kondisi kelompok masyarakat miskin dan rentan.
          </p>

          {/* Highlight Angka */}
          <div className="grid grid-cols-2 gap-6 mt-8">
            <div>
              <p className="text-2xl font-bold text-red-600">25+ Juta</p>
              <p className="text-xs md:text-base text-slate-500">Penduduk hidup di bawah garis kemiskinan</p>
            </div>
            <div>
              <p className="text-2xl font-bold text-red-600">40%</p>
              <p className="text-xs md:text-base text-slate-500">Masyarakat rentan jatuh miskin</p>
            </div>
          </div>
        </div>

        {/* KANAN — Progress Provinsi */}
        <div className="bg-white px-8 py-4 rounded-3xl shadow-sm">
          <h4 className="text-base md:text-lg font-semibold text-slate-800 mb-6">Wilayah dengan Tingkat Kemiskinan Tertinggi</h4>

          <div className="space-y-5">
            {visibleData.map((prov, index) => {
              const isOpen = activeProvince === prov.province;

              return (
                <div key={index} className="space-y-3">
                  {/* PROVINSI */}
                  <button onClick={() => setActiveProvince(isOpen ? null : prov.province)} className="w-full text-left">
                    <div className="flex items-center justify-between mb-2 gap-3">
                      <span className="font-semibold text-gray-800">{prov.province}</span>

                      <div className="flex items-center gap-3">
                        <span className="text-sm text-gray-500">{prov.percentage}%</span>

                        <ChevronDown className={`w-4 h-4 text-gray-500 transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`} />
                      </div>
                    </div>

                    <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
                      <div className="bg-red-600 h-3 rounded-full transition-all duration-700" style={{ width: `${prov.percentage}%` }} />
                    </div>
                  </button>

                  {/* LIST KOTA */}
                  {isOpen && (
                    <div className="ml-4 pl-4 border-l border-gray-300 space-y-2">
                      {prov.cities.map((city, i) => (
                        <div key={i} className="flex justify-between text-sm text-gray-700">
                          <span>{city.city}</span>
                          <span className="text-gray-500">{city.percentage.toLocaleString("id-ID")} Jiwa</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {/* BUTTON SELENGKAPNYA */}
          <div className="mt-6 text-center">
            <button onClick={() => setShowAll((prev) => !prev)} className="text-sm font-semibold text-red-600 hover:underline transition">
              {showAll ? "Tutup" : "Selengkapnya"}
            </button>
          </div>

          <p className="text-xs text-slate-400 mt-4">*Data estimasi berbasis prioritas program dan wilayah intervensi.</p>
        </div>
      </div>
    </section>
  );
};

export default Lanscape;
